import { Component, OnInit } from '@angular/core';
import { DialogComponent, NamedDialog } from '@tytapp/common';

@NamedDialog('missionTaskCompleted')
@Component({
    selector: 'tyt-task-completed',
    templateUrl: './task-completed.component.html',
    styleUrls: ['./task-completed.component.scss']
})
export class TaskCompletedComponent extends DialogComponent {

    actionText: string;
    completed: boolean;

    title: string;
    mainText: string;
    progress: number;

    init(title: string, progress = 0): void {
        this.title = title;
        this.mainText = this.completed ? 'You’ve earned this awesome badge for your incredible work!' : 'Return to the Petition page to complete more tasks, and fufill the mission!';
        this.completed = progress < 1;
        this.progress = progress;
        this.actionText = this.completed ? 'Complete the Mission' : 'Back to petition';
    }

}
